/** @format */
import { Address, TransactionSummary } from '.';
import { Adjustment } from './adjustment';
import { Attribute } from './attribute';
import { CustomerDetails } from './customer';
import { LineItemState } from './line-item';
import { PriceModifier } from './price-modifier';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum PublicTransactionQuoteState {
    UNDEFINED = 'UNDEFINED',
    REQUESTED = 'REQUESTED',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
    ACCEPTED = 'ACCEPTED',
    UPDATED = 'UPDATED',
    ADJUSTED = 'ADJUSTED',
    COMPLETE = 'COMPLETE',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum PublicQuoteItemState {
    UNDEFINED,
    PROPOSED,
    ACCEPTED,
    DECLINED,
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum QuoteExpiryState {
    UNEXPIRED = 'UNEXPIRED',
    EXPIRED = 'EXPIRED',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum QuoteSummaryState {
    PROCESSING = 'PROCESSING',
    QUOTED = 'QUOTED',
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    BOOKED = 'BOOKED',
    BLOCKED = 'BLOCKED',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface QuoteItemSummary {
    id: string;
    itemId?: string;
    modelId: number;
    condition: string;
    productId: number;
    value: number;
    lineItemId: string;
    state: PublicQuoteItemState;
    attributes: Attribute[];
    priceModifiers: PriceModifier[];
    observations: QuoteItemObservation[];
    baseValue?: number;
    adjustments?: Adjustment[];
    lineItemState?: LineItemState;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface QuoteItemObservation {
    id: string;
    observationId: number;
    tierId: number;
    adjustment: number;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface QuoteDeliveryOption {
    collectionDate?: string;
    deliveryOption: string | number | undefined;
    expectedPackageCount: number | undefined;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface QuoteSummary {
    collectionAddress: Address;
    customer: CustomerDetails;
    customerAddress: Address;
    deliveryOption: QuoteDeliveryOption;
    id: string;
    goodsInKnown: QuoteItemSummary[];
    goodsInUnknown: QuoteItemSummary[];
    goodsOut: QuoteItemSummary[];
    state: QuoteSummaryState;
    transactionId: string;
    transaction: TransactionSummary;
}
